import React from 'react';
import DropdownList from 'react-widgets/DropdownList';
import { TipoClave } from './ComboSelector.js';
import * as FuncionesPersona from '../../funciones/FuncionesPersona.js';
import './ComboSelector.scss';

/**
 * Combo selector para participantes de formación que pueden tener persona o personaSinId
 * @param {Array} lista - Array de participantes de formación
 * @param {string} valorActual - Texto del valor actualmente seleccionado
 * @param {Function} onItemElegido - Callback cuando se elige un participante
 * @param {boolean} isCargando - Indica si está cargando
 * @param {boolean} disabled - Indica si está deshabilitado
 * @param {string} estilo - Clase CSS adicional
 */
const ComboSelectorParticipante = (props) => {
  const id = props.id;
  const lista = props.lista;
  const valorActual = props.valorActual;
  const isCargando = props.isCargando;
  const disabled = props.disabled;
  const estilo = props.estilo;

  // Convertir lista de participantes a formato con texto descriptivo
  const listaConvertida = lista.map((participante) => {
    return {
      ...participante,
      textoParticipante: FuncionesPersona.TextoParticipante(participante),
    };
  });

  const onItemElegido = (item) => {
    props.onItemElegido(item);
  };

  return (
    <React.Fragment>
      <DropdownList
        key={id}
        className={estilo}
        busy={isCargando}
        disabled={disabled}
        filter="contains"
        datakey={TipoClave.ID}
        textField={'textoParticipante'}
        value={valorActual}
        data={listaConvertida}
        onChange={onItemElegido}
      />
    </React.Fragment>
  );
};

export default ComboSelectorParticipante;
